export default {
  birth: 'Surat Keterangan Pencatatan Kelahiran',
  married: 'Surat Keterangan Pernikahan',
  death: 'Surat Keterangan Kematian',
  death2: 'Surat Keterangan Pengiriman Abu Jenazah',
  domisili: 'Surat Keterangan Domisili',
  move: 'Surat Keterangan Barang Pindahan'
};
